/**
 * Generated from MainMenuLayout.fla
 */
export function MainMenuLayout(this: IMainMenuLayout) {
	const bg = this.bg;
	MainMenuLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const logo = this.logo;
	MainMenuLayout_logo.call(this.logo);
	logo.x = 499.85;
	logo.y = 172.4;
	logo.width = 565.04;
	logo.height = 104.15;
	if (logo.onLayout) logo.onLayout();
	const playButton = this.playButton;
	MainMenuLayout_playButton.call(this.playButton);
	playButton.x = 512.5;
	playButton.y = 351;
	playButton.width = 268.50;
	playButton.height = 114.50;
	if (playButton.onLayout) playButton.onLayout();
	const freeplayButton = this.freeplayButton;
	MainMenuLayout_freeplayButton.call(this.freeplayButton);
	freeplayButton.x = 512.5;
	freeplayButton.y = 484.5;
	freeplayButton.width = 268.50;
	freeplayButton.height = 114.50;
	if (freeplayButton.onLayout) freeplayButton.onLayout();
	return this;
}
function MainMenuLayout_bg(this: IMainMenuLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-bg@2x.png", 0.500, 0.500);
	return this;
}
function MainMenuLayout_logo(this: IMainMenuLayout_logo) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-logo.png", 0.500, 0.502);
	return this;
}
function MainMenuLayout_playButton(this: IMainMenuLayout_playButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-mainmenu-play-btn.png", 0.500, 0.500);
	return this;
}
function MainMenuLayout_freeplayButton(this: IMainMenuLayout_freeplayButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-mainmenu-training-btn.png", 0.500, 0.500);
	return this;
}
interface IMainMenuLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IMainMenuLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IMainMenuLayoutSprite extends IMainMenuLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IMainMenuLayoutText extends IMainMenuLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IMainMenuLayoutPolygon extends Array<number> {
}
interface IMainMenuLayout {
	readonly bg: IMainMenuLayout_bg;
	readonly logo: IMainMenuLayout_logo;
	readonly playButton: IMainMenuLayout_playButton;
	readonly freeplayButton: IMainMenuLayout_freeplayButton;
}
interface IMainMenuLayout_bg extends IMainMenuLayoutSprite {
}
interface IMainMenuLayout_logo extends IMainMenuLayoutSprite {
}
interface IMainMenuLayout_playButton extends IMainMenuLayoutSprite {
}
interface IMainMenuLayout_freeplayButton extends IMainMenuLayoutSprite {
}
